<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.code" placeholder="脚本编号" @keyup.enter.native="queryList"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.name" placeholder="脚本名称" @keyup.enter.native="queryList"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="queryList">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
			<el-table-column label="操作" width="180">
				<template slot-scope="scope">
					<el-row>
						<el-button type="primary" icon="el-icon-edit" circle size="mini" @click="handleEdit(scope.$index, scope.row)"></el-button>
						<el-button type="warning" size="mini" @click="handleSqlEdit(scope.$index, scope.row)">Sql</el-button>
					</el-row>
				</template>
			</el-table-column>
			<el-table-column prop="entime" label="时间" min-width="100"></el-table-column>
			<el-table-column prop="code" label="脚本编号" min-width="80"></el-table-column>
			<el-table-column prop="name" label="脚本名称" min-width="100"></el-table-column>
			<el-table-column prop="tbl_name" label="关联表" min-width="100"></el-table-column>
		</el-table>
		<!--工具条翻页-->
		<el-col :span="24" class="toolbar">
		<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
		</el-col>
		<el-drawer
		  :title="editformtitle"
		  :visible.sync="editFormVisible" :before-close="clickClose"
		  size="70%" :with-header="false"
		  direction="rtl">
			<!--编辑界面-->
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm" label-width="180px" v-loading="createLoading">
				<el-container>
					<el-container style="min-height: 100vh;">
						<el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;">
						  <!-- 头部内容 -->			  
						  <div>
							{{editformtitle}}
						  </div>
						</el-header>
					</el-header>
					<el-main>
						<el-form-item label="脚本编号" prop="code">
							<el-input v-model="editForm.code" placeholder="脚本编号" style="width:200px" readonly="true"></el-input>
						</el-form-item>
						<el-form-item label="脚本名称" prop="name">
							<el-input v-model="editForm.name" placeholder="脚本名称" style="width:200px"></el-input>
						</el-form-item>
						<el-form-item label="关联数据表" prop="tbl_name">
							<el-input v-model="editForm.tbl_name" placeholder="关联数据表" style="width:200px"></el-input>
						</el-form-item>
						<el-form-item label="Vue配置">
							<el-input v-model="editForm.vue_conf" placeholder="配置数据" type="textarea" :autosize="{ minRows: 15, maxRows: 22}"></el-input>
						</el-form-item>
					</el-main>
					<el-footer>
						<div class="to-right">
							<el-button @click.native="editFormVisible = false">取消</el-button>
							<el-button type="primary" @click.native="editSubmit" :loading="editLoading">保存</el-button>
						  </div>
					</el-footer>
				</el-container>
				
				
			</el-form>
		</el-drawer>
		<el-drawer
		  :visible.sync="editSqlFormVisible" :before-close="clickClose"
		  size="70%" :with-header="false" direction="rtl">
			<!--编辑界面-->
			<el-container>
				<el-header>
					<el-button type="info" icon="el-icon-circle-close" size="mini" @click.native="editSqlFormVisible = false">关闭</el-button>
					<el-button v-if="addCreateSqlBtnVis" type="primary" icon="el-icon-document-add" size="mini" @click.native="addSqls">一键添加</el-button>
					<el-button type="primary" icon="el-icon-document-add" size="mini" @click.native="editSqlHandleAdd">新增SQL</el-button>
				</el-header>
				<el-main>
					<el-descriptions>
						<el-descriptions-item label="命名空间">
							<el-input v-model="namespace" placeholder="填写命名空间" style="width:200px"></el-input>
						</el-descriptions-item>
					</el-descriptions>
					<el-table :data="sqlsData.data" border stripe highlight-current-row style="width:90%;" height="600">
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<el-row>
									<el-button type="primary" icon="el-icon-edit" circle size="mini" @click="editSqlHandleEdit(scope.$index, scope.row)"></el-button>
									<el-button type="danger" icon="el-icon-delete" circle size="mini" @click="delSqlHandSubmit(scope.$index, scope.row)"></el-button>
								</el-row>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="名称" min-width="100">
							<template slot-scope="scope">
								<div>
									{{jscode+"."+namespace+'.'+scope.row.name}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="sql" label="Sql" min-width="150"></el-table-column>
					</el-table>
				</el-main>
			</el-container>
		</el-drawer>
		<el-drawer
		  title="脚本Sql编辑"
		  :visible.sync="editSqlHandFormVisible" :before-close="clickClose"
		  size="50%" :with-header="false"
		  direction="rtl">
			<!--编辑界面-->
			<el-form :model="editSqlHandForm" label-width="100px" ref="editSqlHandForm" label-width="180px">
				<el-form-item >
					<el-button @click.native="editSqlHandFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="editSqlHandSubmit">保存</el-button>
				</el-form-item>
				<el-form-item label="SQL名称" prop="name">
					<el-input v-model="editSqlHandForm.name" placeholder="SQL名称" style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="SQL" prop="sql">
					<el-input v-model="editSqlHandForm.sql" type="textarea" :autosize="{ minRows: 10, maxRows: 25}"></el-input>
				</el-form-item>
			</el-form>
		</el-drawer>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
					code:'',name:''
				},
				isRunExecFlag:false,
				datalist: [],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				createLoading:false,
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				//////////////////
				namespace:'',
				jscode:'',
				tableName:'',
				editSqlFormVisible: false,
				editSqlHandFormVisible:false,
				sqlsData:{},
				editSqlHandForm:{name:'',sql:''},
				addCreateSqlBtnVis:true,
				///////////////////////////////////////////////
				editLoading: false,
				formRules: {
					code :[
						{required: true,message: '脚本编号不能为空!',trigger: 'blur'}
					],
					name :[
						{required: true,message: '脚本名称不能为空!',trigger: 'blur'}
					],
					tbl_name :[
						{required: true,message: '管理数据表不能为空!',trigger: 'blur'}
					],
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',name:'',code:'',tbl_name:'',vue_conf:'',id:''
				}
			}
		},
		methods: {
			handleCurrentChange:function(val){
				this.page = val;
				this.getLists();
			},
			queryList:function(){
				this.page = 1 ;
				this.getLists();
			},
			getLists:function(){
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getList',
					name:this.filters.name,
					code:this.filters.code,
					sqlid:'a7iJ8Si.conf_dev.query'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
				///////////
				if(this.isRunExecFlag) {
					this.isRunExecFlag = false ;
					this.runExecGo();
				}
			},
			addSqls:function(){
				let para = {
					actionurl:'cfjs/createSqls',code:this.jscode,namespace:this.namespace,tableName:this.tableName
				};
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.editSqlList();
					}
				});
			},
			handleAdd:function(){
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',sqlid:'a7iJ8Si.conf_dev.add',name:'',code:'',tbl_name:'',vue_conf:''
				};
				let para = {
					actionurl:'cfjs/getCode'
				};
				this.createLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.editForm.code = res.data.codeKey;
					}
					this.createLoading = false;
				});
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				try{
					let ss = JSON.stringify(row.vue_conf,null,2);
					//console.log(">>>>"+ss);
					if(ss.indexOf("{")>=0){
						this.editForm.vue_conf = ss;
						//console.log(">>>>OK>>"+this.editForm.vue_conf);
					}
				}catch(e){}
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'a7iJ8Si.conf_dev.upt';
			},
			handleVueEdit:function(index,row){
				this.editSqlFormVisible = true;
				this.jscode = row.code;
				this.tableName = row.tbl_name;
				this.editSqlList();
			},
			handleSqlEdit:function(index,row){
				this.editSqlFormVisible = true;
				this.jscode = row.code;
				this.tableName = row.tbl_name;
				this.editSqlList();
			},
			editSqlList:function(){
				let para = {
					actionurl:'cfjs/sqlList',code:this.jscode
				};
				this.addCreateSqlBtnVis = true ;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.sqlsData = res.data;
						this.namespace = this.sqlsData.namespace;
						if(res.data.size>0){
							this.addCreateSqlBtnVis = false ;
						}
					}
					this.createLoading = false;
				});
			},
			editSqlHandleAdd:function(){
				this.editSqlHandFormVisible = true ;
				this.editSqlHandForm.name = '';
				this.editSqlHandForm.sql = '';
			},
			editSqlHandleEdit:function(index,row){
				//编辑
				this.editSqlHandFormVisible = true ;
				this.editSqlHandForm.name = row.name;
				this.editSqlHandForm.sql = row.sql;
			},
			editSqlHandSubmit:function(){
				let para = {
					actionurl:'cfjs/submitSql',code:this.jscode,name:this.editSqlHandForm.name,sql:this.editSqlHandForm.sql
				};
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.editSqlHandFormVisible = false ;
						this.runExecGo();
						this.editSqlList();
					}
				});
			},
			runExecGo:function(){
				let para = {
					actionurl:'default/runExec',execs:'reloadConf',sqlid:'runExec'
				};
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.$message({message: res.data.message,type: res.data.type});
					}
				});
			},
			delSqlHandSubmit:function(index,row){
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					let para = {
						actionurl:'cfjs/delSql',code:this.jscode,name:row.name
					};
					delData(para).then((res) => {
						this.$message({message: res.data.message,type: res.data.type});
						this.editSqlList();
					});
				}).catch(() => {});
			},
			editSubmit:function(){
				this.isRunExecFlag = true ;
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
				
			},
			clickClose:function(){
				
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					this.listLoading = true;
					let para = {
						actionurl:'default/del',
						sqlid:'a7iJ8Si.conf_dev.del',
						id:row.id
					};
					delData(para).then((res) => {
						this.listLoading = false;
						this.$message({message: res.data.message,type: res.data.type});
						this.getLists();
					});
				}).catch(() => {});
			}
		},
		mounted() {
			this.getLists();
		}
	}	
</script>
<style scoped>
	.el-header {
	  background-color:#eceef3;
	  color: #409eff;
	  padding-left:50px;
	  text-align: left;
	  line-height: 60px;
	}
	.el-footer{
		padding-top:10px;
		position:absolute;
		bottom:0;
		width:100%;
		background:#f7f9fd;
		color:white;
	}
	.to-right{
		position: fixed;
		right: 20px;
	}
	.el-main {
	  margin-top: 60px; /* 头部高度 */
	  padding: 0px;
	  margin-right:20px;
	  margin-bottom:40px;
	}
	.box-card-edit{
		height:500px;
	}
</style>


// WEBPACK FOOTER //
// confJs.vue?5e396962